<template>
<div>
  <div class="col-md-12 card">
    <div class="card-content row">
      <div class="col-sm-6 col-md-9">
      </div>
      <div class="col-sm-6 col-md-3">
        <p-search @on-search="handleSearch($event)"></p-search>
      </div>
      <div class="col-sm-12">
        <el-table
          class="table-striped"
          :data="tableData"
          :default-sort="{prop: 'createdAt', order: 'descending'}"
          @sort-change="handleSort($event)"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="Nome"
            sortable="custom"
            :min-width="200"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="Categoria"
            sortable="custom"
            :min-width="200"
          >
            <template slot-scope="scope">
            {{ scope.row.categorieId && categories.hasOwnProperty(scope.row.categorieId) ? categories[scope.row.categorieId].name : '' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="Criado Em"
            sortable="custom"
            :min-width="120"
          >
            <template slot-scope="scope">
            {{ new Date(scope.row.createdAt) | moment('DD/MM/YYYY HH:mm:ss') }}
            </template>
          </el-table-column>
          <el-table-column
            :width="100"
            fixed="right"
            label="Ações"
          >
            <template slot-scope="props">
            <actions-table-tags :tag="props.row" :handleRemove="handleRemove"></actions-table-tags>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="col-sm-12 text-center">
        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        ></p-pagination>
      </div>
    </div>
  </div>
  <div class="col-sm-12 pagination-info text-right">
    <p class="category">Mostrando de {{from + 1}} até {{to}} de {{total}} no total.</p>
  </div>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ActionsTableTags from '../../../components/Trg/Tags/ActionsTableTags'

export default {
  name: 'index-tag',

  components: { ActionsTableTags },

  data () {
    return {
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      sort: {
        field: 'createdAt',
        direction: 'desc'
      },
      search: {
        query: '',
        fields: ['name', 'informativeText']
      }
    }
  },

  computed: {
    ...mapGetters('categories', {
      categories: 'modelById'
    }),
    ...mapGetters('tags', {
      tableData: 'tags',
      count: 'count',
      loading: 'loading'
    }),
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.count
      return this.count
    },
    currentPage () {
      return this.pagination.currentPage
    }
  },

  watch: {
    currentPage: function () {
      this.fetch()
    }
  },

  methods: {
    ...mapActions('categories', {
      fetchCategories: 'fetchAll'
    }),
    ...mapActions('tags', ['fetchAll', 'delete']),
    fetch () {
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'search': this.search
      })
    },
    handleSearch (query) {
      this.search.query = query
      this.fetch()
    },
    handleSort (sort) {
      // this.sort = {field: sort.prop, direction: sort.order}
      this.fetch()
    },
    handleRemove (params) {
      const swal = require('sweetalert2')
      swal({
        title: 'Você tem certeza?',
        text: `Não será possível reverter essa ação!`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      }).then(res => {
        if (res) {
          this.delete(params.id)
            .then(result => {
              this.$notify({
                message: 'Registro deletado com sucesso.',
                type: 'success'
              })
              this.fetch()
            })
            .catch(err => console.log(err))
        }
      })
    }
  },

  mounted () {
    this.fetchCategories({ limit: 999 })
    this.fetch()
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/ConfigurationsPages/Tag/TagIndex.vue